module.exports = __webpack_public_path__ + "static/media/media2.7f56bb75.png";